const defaultTextValues = {
  sectionTitle: {
    en: 'Event starts in:'
  },
  countdownSubtitleDays: {
    en: 'days'
  },
  countdownSubtitleHours: {
    en: 'hours'
  },
  countdownSubtitleMinutes: {
    en: 'minutes'
  },
  countdownSubtitleSeconds: {
    en: 'seconds'
  },
};

export default defaultTextValues;
